import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    prepareLoading: false,
    prepareResult: null,
    prepareErrorMessage: null,

    directChargeLoading: false,
    directChargeSuccessMessage: null,
    directChargeErrorMessage: null,

    previewLoading: false,
    previewResult: null,
    previewErrorMessage: null,

    reviewItems: null,
    reviewItemsLoading: false,
    reviewItemsErrorMessage: null,
    updateItemLoading: {},
    deleteItemLoading: {},

    chargeLoading: false,
    chargeErrorMessage: null,
    chargeSuccessMessage: null,

    reportLoading: false,
    reportErrorMessage: null,
    reportSuccessMessage: null,

    importLoading: false,
    importErrorMessage: null,
    importSuccessMessage: null,

    gsheetLinks: null,
    gsheetLinksLoading: false,

    preparationErrors: null,
    preparationErrorsLoading: false,
};

const chargingSlice = createSlice({
    name: "Charging",
    initialState,
    reducers: {
        // Prepare
        prepareRequest(state) {
            state.prepareLoading = true;
            state.prepareResult = null;
            state.prepareErrorMessage = null;
        },
        prepareSuccess(state, action) {
            state.prepareLoading = false;
            state.prepareResult = action.payload;
        },
        prepareFailure(state, action) {
            state.prepareLoading = false;
            state.prepareErrorMessage = action.payload;
        },

        // Direct charge (prepare + charge in one shot)
        directChargeRequest(state) {
            state.directChargeLoading = true;
            state.directChargeSuccessMessage = null;
            state.directChargeErrorMessage = null;
        },
        directChargeSuccess(state, action) {
            state.directChargeLoading = false;
            state.directChargeSuccessMessage = action.payload;
        },
        directChargeFailure(state, action) {
            state.directChargeLoading = false;
            state.directChargeErrorMessage = action.payload;
        },

        // Preview
        previewRequest(state) {
            state.previewLoading = true;
            state.previewResult = null;
            state.previewErrorMessage = null;
        },
        previewSuccess(state, action) {
            state.previewLoading = false;
            state.previewResult = action.payload;
        },
        previewFailure(state, action) {
            state.previewLoading = false;
            state.previewErrorMessage = action.payload;
        },
        clearPreview(state) {
            state.previewResult = null;
            state.previewErrorMessage = null;
        },

        // Review items
        getReviewItemsRequest(state) {
            state.reviewItemsLoading = true;
            state.reviewItems = null;
            state.reviewItemsErrorMessage = null;
        },
        getReviewItemsSuccess(state, action) {
            state.reviewItemsLoading = false;
            state.reviewItems = action.payload;
        },
        getReviewItemsFailure(state, action) {
            state.reviewItemsLoading = false;
            state.reviewItemsErrorMessage = action.payload;
        },

        updateItemRequest(state, action) {
            state.updateItemLoading[action.payload] = true;
            state.reviewItemsErrorMessage = null;
        },
        updateItemSuccess(state, action) {
            delete state.updateItemLoading[action.payload.externalUUID];
            if (state.reviewItems) {
                const idx = state.reviewItems.findIndex(
                    (item) => item.externalUUID === action.payload.externalUUID
                );
                if (idx >= 0) {
                    state.reviewItems[idx] = action.payload;
                }
            }
        },
        updateItemFailure(state, action) {
            delete state.updateItemLoading[action.payload.externalUUID];
            state.reviewItemsErrorMessage = action.payload.error;
        },

        deleteItemRequest(state, action) {
            state.deleteItemLoading[action.payload] = true;
            state.reviewItemsErrorMessage = null;
        },
        deleteItemSuccess(state, action) {
            delete state.deleteItemLoading[action.payload];
            if (state.reviewItems) {
                state.reviewItems = state.reviewItems.filter(
                    (item) => item.externalUUID !== action.payload
                );
            }
        },
        deleteItemFailure(state, action) {
            delete state.deleteItemLoading[action.payload.externalUUID];
            state.reviewItemsErrorMessage = action.payload.error;
        },

        // Charge
        chargeRequest(state) {
            state.chargeLoading = true;
            state.chargeErrorMessage = null;
            state.chargeSuccessMessage = null;
        },
        chargeSuccess(state, action) {
            state.chargeLoading = false;
            state.chargeSuccessMessage = action.payload;
        },
        chargeFailure(state, action) {
            state.chargeLoading = false;
            state.chargeErrorMessage = action.payload;
        },

        // Report
        reportRequest(state) {
            state.reportLoading = true;
            state.reportErrorMessage = null;
            state.reportSuccessMessage = null;
        },
        reportSuccess(state, action) {
            state.reportLoading = false;
            state.reportSuccessMessage = action.payload;
        },
        reportFailure(state, action) {
            state.reportLoading = false;
            state.reportErrorMessage = action.payload;
        },

        // Import
        importRequest(state) {
            state.importLoading = true;
            state.importErrorMessage = null;
            state.importSuccessMessage = null;
        },
        importSuccess(state) {
            state.importLoading = false;
            state.importSuccessMessage = "Report wurde erfolgreich hochgeladen";
        },
        importFailure(state, action) {
            state.importLoading = false;
            state.importErrorMessage = action.payload;
        },

        // GSheet links
        getGSheetLinksRequest(state) {
            state.gsheetLinksLoading = true;
        },
        getGSheetLinksSuccess(state, action) {
            state.gsheetLinksLoading = false;
            state.gsheetLinks = action.payload;
        },
        getGSheetLinksFailure(state) {
            state.gsheetLinksLoading = false;
            state.gsheetLinks = null;
        },

        // Preparation errors
        getPreparationErrorsRequest(state) {
            state.preparationErrorsLoading = true;
            state.preparationErrors = null;
        },
        getPreparationErrorsSuccess(state, action) {
            state.preparationErrorsLoading = false;
            state.preparationErrors = action.payload;
        },
        getPreparationErrorsFailure(state) {
            state.preparationErrorsLoading = false;
            state.preparationErrors = null;
        },

        clearMessages(state) {
            state.prepareErrorMessage = null;
            state.prepareResult = null;
            state.directChargeErrorMessage = null;
            state.directChargeSuccessMessage = null;
            state.previewErrorMessage = null;
            state.previewResult = null;
            state.chargeErrorMessage = null;
            state.chargeSuccessMessage = null;
            state.reportErrorMessage = null;
            state.reportSuccessMessage = null;
            state.importErrorMessage = null;
            state.importSuccessMessage = null;
            state.reviewItemsErrorMessage = null;
        },
    },
});

export default chargingSlice;
